$(document).ready(function () {
	var mainMenu = $("header.header"),
		btnMenu = $(".btn.header__menu-btn");
	btnMenu.click(function () {
		mainMenu.toggleClass("header--open");
	});
});
